import apiService from "services/api";
import { CustomModal, CustomAlert } from "components";
import { useNotificationContext } from "contexts";
import { Button } from "reactstrap";
import { capitalize } from "utils/capitalize";
import { modalActions, modalInitialState } from "../reducers";
import { ModalBody } from "./ModalBody";
import { isLeaveDeletionAllowed } from "pages/StaffApplication/constants";

export const StaffApplicationModal = ({ state, dispatch, type, refetch, expandImage }) => {
	const { createNotification } = useNotificationContext();
	const deletable = type === "leave" && isLeaveDeletionAllowed(state?.data?.date);
	const hideConfirmationModal = () => dispatch({ type: modalActions.MODAL_CLOSE });
	const hideAlert = () => dispatch({ type: modalActions.ALERT_CLOSE });

	const submitDelete = () => {
		if (!deletable) return;
		var api = () => apiService.leave.delete(state?.data?.id);

		api()
			.then((data) => {
				createNotification({
					type: "success",
					message: `Successfully deleted ${type}`,
				});
				hideAlert();
				hideConfirmationModal();
				refetch();
			})
			.catch((error) =>
				createNotification({
					type: "danger",
					message: `Error deleting ${type}: ${error.message}`,
				})
			);
	};

	return (
		<>
			<CustomAlert
				show={state?.alertOpen}
				hideModal={() => dispatch({ type: modalActions.ALERT_CLOSE })}
				title="Delete Application?"
				body={
					<div className="text-white">
						Are you sure you want to delete application on
						<span className="text-info"> {new Date(state?.data?.date).toLocaleDateString()}?</span>
						<div className="text-warning mt-3">
							**Leaves can only be deleted more than 2 days before the leave date. Deletion leaves a trace in the database for audit purposes.
						</div>
					</div>
				}
				submitButtonText="Confirm"
				submitModal={submitDelete}
			/>
			<CustomModal
				title={`${capitalize(type)} Application`}
				show={state?.modalOpen}
				hideModal={hideConfirmationModal}
				submitButtonText="Approve"
				buttons={
					<>
						<Button onClick={() => dispatch({ type: modalActions.ALERT_OPEN })} color="primary" disabled={!deletable}>
							{type !== "leave" ? "OT Cannot Delete" : !deletable ? "Cannot Delete" : "Delete"}
						</Button>
					</>
				}
			>
				<ModalBody state={state} expandImage={expandImage} type={type} />
			</CustomModal>
		</>
	);
};
